import React from "react";
import ProductPage from "./ProductPage";

const sofas = [
  {
    id: 1,
    title: "Modern Sofa",
    description: "Comfortable modern sofa",
    image: "/images/sofa/sofa1.png",
  },
  {
    id: 2,
    title: "Luxury Sofa",
    description: "Premium luxury sofa",
    image: "/images/sofa/sofa2.png",
  },
  {
    id: 3,
    title: "Classic Sofa",
    description: "Elegant classic design",
    image: "/images/sofa/sofa3.png",
  },
  {
    id: 3,
    title: "Classic Sofa",
    description: "Elegant classic design",
    image: "/images/sofa/sofa4.png",
  },
  {
    id: 3,
    title: "Classic Sofa",
    description: "Elegant classic design",
    image: "/images/sofa/sofa5.png",
  },
  {
    id: 3,
    title: "Classic Sofa",
    description: "Elegant classic design",
    image: "/images/sofa/sofa6.png",
  },
  {
    id: 3,
    title: "Classic Sofa",
    description: "Elegant classic design",
    image: "/images/sofa/sofa7.png",
  },
  {
    id: 3,
    title: "Classic Sofa",
    description: "Elegant classic design",
    image: "/images/sofa/sofa8.png",
  },
  {
    id: 3,
    title: "Classic Sofa",
    description: "Elegant classic design",
    image: "/images/sofa/sofa9.png",
  },
  {
    id: 3,
    title: "Classic Sofa",
    description: "Elegant classic design",
    image: "/images/sofa/sofa10.png",
  },
 
  
];

const SofaPage = () => {
  return (
    <ProductPage
      title="Sofa Collection"
      subtitle="Discover our premium sofas"
      bannerImage="/images/sofa21.png"
      products={sofas}
    />
  );
};

export default SofaPage;